import { useTranslation } from 'react-i18next'
import type { QuickSuggestionProps } from '@/types/chatbot'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-wrap gap-1.5 sm:gap-2 justify-center">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className="px-3 py-2 sm:px-4 sm:py-2 text-xs sm:text-sm bg-white hover:bg-gray-100 text-gray-700 rounded-full transition-colors disabled:opacity-50 shadow-sm border border-gray-200 cursor-pointer min-h-[36px]"
        >
          {t(suggestion.labelKey)}
        </button>
      ))}
    </div>
  )
}
